// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falStarSharpHalf: CreateIconOptions = {
  "displayName": "FALStarSharpHalf",
  "viewBox": "0, 0, 576, 512",
  "d": "M272 93.9L239.2 196.9C237.1 203.5 231 208 224 208L75.3 208l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6 272 376.2l0-282.3zm-8.3-79.5C266.5 5.8 274.4 0 283.4 0C294.8 0 304 9.2 304 20.6L304 384c0 4.9-2.3 9.6-6.2 12.6l-142.7 111c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176l153.7 0L263.7 14.4z"
};
